<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-ministry-sidebar></app-ministry-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint
                "
              >
                <div class="card-heading">
                  <h4>List of Passenger's COVID-19 Result</h4>
                </div>

                <div class="button-section mt-1"></div>
              </div>

              <div class="card-body">
                <div class="col-lg-12">
                  <div class="col-lg-12">
                    <form
                      [formGroup]="searchForm"
                      (ngSubmit)="onSubmitSearch(searchForm.value)"
                    >
                      <div class="row">
                       
                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <select
                            class="form-select select-option col-lg-12"
                            name="traveller_type"
                            formControlName="traveller_type"
                            id="traveller_type"
                          >
                          <option selected value="">Type of Traveller</option>
                          <option
                            *ngFor="let type of shared.travelTypes"
                            [value]="type.id"
                          >
                            {{ type.name }}
                          </option>
                          </select>
                        </div>

                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <select
                            class="form-select select-option col-lg-12"
                            name="test_result"
                            formControlName="test_result"
                            id="test_result"
                          >
                          <option selected value="">Test Result</option>
                          <option value="Positive">Positive</option>
                          <option value="Negative">Negative</option>
                          </select>
                        </div>

                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <select
                            class="form-select select-option col-lg-12"
                            name="medical_lab"
                            formControlName="medical_lab"
                            id="medical_lab"
                          >
                          <option selected value="">Medical Labs</option>
                          <option
                            *ngFor="let type of shared.labs"
                            [value]="type.id"
                          >
                            {{ type.name }}
                          </option>
                          </select>
                        </div>

                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <input
                            class="form-control"
                            type="date"
                            formControlName="validity_date"
                          placeholder="Validity date"
                          title="Validity date"
                          />
                        </div>
                       
                      </div>


                      <div class="form-row mt-3">
                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <input
                            class="form-control icon-cal font-12"
                            type="text"
                            formControlName="daterangeInput"
                            placeholder="Sample Collection Date: Date From - Date To"
                            daterangepicker
                            [options]="options"
                            (selected)="selectedDate($event, daterange)"
                            title="Sample Collection Date: Date From - Date To"
                          />
                        </div>

                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <div class="mr-4">
                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                              "
                              type="submit"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fas fa-search"></i> Search
                            </button>

                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                                ml-2
                              "
                              type="button"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                              (click)="clearSearch()"
                            >
                              <i class="fas fa-sync-alt"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>


                    </form>
                  </div>

                  <div class="">
                    <div class="mt-3">
                      <div class="col-auto">
                        <div class="row" *ngIf="totalresults">
                          <div class="show-record mt-3 mbm-32">
                            <span>Show</span> &nbsp;
                            <select
                              class="
                                custom-select custom-select-sm
                                form-control form-control-sm
                              "
                              (change)="setItemsPerPage(page.value)"
                              #page
                            >
                              <option [selected]="currentPageLength == 10">
                                10
                              </option>
                              <option [selected]="currentPageLength == 30">
                                30
                              </option>
                              <option [selected]="currentPageLength == 50">
                                50
                              </option>
                              <option [selected]="currentPageLength == 100">
                                100
                              </option>
                              <option [selected]="currentPageLength == 500">
                                500
                              </option>
                              <option [selected]="currentPageLength == 1000">
                                1000
                              </option>
                            </select>
                            &nbsp;
                            <span> entries</span>
                          </div>
                        </div>
                      </div>
                      <div class="table table-responsive">
                        <table
                          *ngIf="totalresults"
                          class=""
                          datatable
                          [dtOptions]="dtOptions"
                          width="100%"
                        >
                          <thead>
                            <tr>
                              <th scope="col">S/N</th>
                              <th scope="col">Type of Traveller</th>
                              <th scope="col">Appointment ID</th>
                              <th scope="col">Passenger Name</th>
                              <th scope="col">Passport Number</th>
                              <th scope="col">Phone Number</th>
                              <th scope="col">Test Result</th>
                              <th scope="col">Medical Lab</th>
                              <th scope="col">Sample Collection Date</th>
                              <th scope="col">Date of Result</th>
                              <th scope="col">Result Validity</th>
                              <th scope="col">Created At</th>
                              <!-- <th scope="col">View Result</th> -->
                            </tr>
                          </thead>
                          <tbody class="dashboard-bg-white">
                            <tr
                            *ngFor="
                              let result of totalresults | paginate: config;
                              index as i
                            "
                          >
                            <th scope="row">
                              {{
                                config.itemsPerPage * (config.currentPage - 1) +
                                  i +
                                  1
                              }}
                            </th>
                            <td>
                              <span *ngIf="result.type == '1'">
                                Departing EG
                              </span>
                              <span *ngIf="result.type == '2'">
                                Arriving EG
                              </span>
                            </td>
                            <td>{{ result.appointment_id }}</td>
                            <td>
                              {{ result.first_name }} {{ result.middle_name }}
                              {{ result.last_name }}
                            </td>
                            <td>{{ result.passport_no }}</td>
                            <td>{{ result.phone }}</td>

                            <td>
                              <span
                                class="text-danger"
                                *ngIf="result.status == 'POSITIVE'"
                              >
                                {{ result.status }}
                              </span>
                              <span
                                class="text-success"
                                *ngIf="result.status != 'POSITIVE'"
                              >
                                {{ result.status }}
                              </span>
                            </td>
                            <td>{{ result.lab_name }}</td>
                            <td>
                              {{
                                result.sample_collected_date | date
                              }}
                            </td>
                            <td>{{ result.result_date | date }}</td>
                            <td>{{ result.validity_date | date }}</td>
                            <td>{{ result.created_at | date }}</td>
                            <!-- <th>
                              <button
                                class="btn-view"
                                type="button"
                                (click)="
                                  showResultDetails(
                                    result,
                                    showResultDetailsModal
                                  )
                                "
                                title="View result"
                              >
                                <i class="far fa-eye"></i>
                              </button>
                            </th> -->
                          </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="table-footer">
                        <div
                          id="page_info"
                          class="mt-3 record-show-text-bottom"
                          *ngIf="totalresults"
                        >
                          Showing
                          {{
                            (config.currentPage - 1) * config.itemsPerPage + 1
                          }}
                          - {{ config.currentPage * config.itemsPerPage }} of
                          {{ config.totalItems }} entries
                        </div>

                        <div
                          class="pagination paging-pull-right"
                          *ngIf="totalresults"
                        >
                          <pagination-controls
                            (pageChange)="pageChange($event)"
                            class="my-pagination mt-2 pagination-server"
                          >
                          </pagination-controls>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #showResultDetailsModal let-modal>
  <div class="card col-lg-12">
    <div class="row">
      <div class="card-header col-lg-12 header-dashboard-button-2">
        <h3>John Doe Result</h3>
        <button class="close-button" (click)="modal.close('Save click')">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="card-body p-4">
        <div class="container">
          <div class="row justify-content-center bg-light">
            <div class="col-md-2">
              <img
                src="https://via.placeholder.com/100"
                width="100"
                height="100"
                alt="Logo"
                class="border rounded-0"
              />
            </div>
            <div class="col-md-10 text-right">
              <h4 class="text-dark font-weight-bold">CLINIX HEALTH CARE</h4>
              <h5 class="text-dark font-weight-normal">
                A MEMBER OF THE EG COVID-19 LABORATORY CONSORTIUM EQUITORIAL
                GUINEA
              </h5>
              <h4 class="text-dark font-weight-bold">
                VIRILOGY PCR TEST REPORT FOR COVID-19
              </h4>
            </div>
            <!-- <div class="col-md-2">
              <img
                src="https://via.placeholder.com/100"
                width="100"
                height="100"
                alt="QR_Code"
                class="border rounded-0"
              />
              <p class="font-weight-bold">No 63028175</p>
            </div> -->

            <!-- <div class="col-md-12">
                <span class="ml-5">To verify the authenticity of this test result, visit
                  <a
                    href="https://covid19.medfit.com.ng/verify-result">https://covid19.medfit.com.ng/verify-result</a></span>
              </div> -->
          </div>

          <!-- <div class="row justify-content-center mt-5">
            <div class="col-md-12 text-center">
              <h4 class="font-weight-bold">
                <u>VIROLOGICAL SCREENING TEST FOR COVID-19 OUTBREAK</u>
              </h4>
            </div>
          </div> -->

          <div class="row mt-4 ml-1">
            <span><strong>Date: </strong><u> 12/02/2021 </u></span>

            <!-- <span class="ml-5"
              >
              <strong>Appointment ID: </strong><u> 484848484 </u>
              </span
            > -->
          </div>

          <div class="container mt-3 bg-white">
            <div class="row">
              <div class="col-md-7 border border-secondary">
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">NAME: </span> John Smith
                    Doe</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">SAMPLE COLLECTED ON: </span>
                    23/07/2021</span
                  >
                  <span class="ml-5">
                    <img
                      src="https://via.placeholder.com/100"
                      width="100"
                      height="100"
                      alt="Logo"
                      class="border rounded-0"
                    />
                  </span>
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">AGE: </span>
                    29
                  </span>
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">SEX: </span>
                    Male
                  </span>
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">ADDRESS: </span> Nafrc,
                    lagos, Nigeria</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">PHONE NO: </span>
                    08036474646</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">EMAIL: </span>
                    mail@gmail.com</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">NATIONALITY: </span>
                    India</span
                  >
                </p>
                <!-- <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">PASSPORT NO.: </span>
                    DO0867543</span
                  >
                </p> -->

                <!-- <p class="text-dark">
                  <span
                    ><span class="font-weight-bold"
                      >COUNTRY OF RESIDENCE:
                    </span>
                    Nigeria</span
                  >
                </p> -->
              </div>

              <!-- <div class="col-md-2">
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">SAMPLE COLLECTED: </span>
                    <br />
                    20/07/2021
                  </span>
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">COLLECTED VIA: </span>
                    <br />
                    Nose
                  </span>
                </p>
             
              </div> -->

              <div class="col-md-5 border border-secondary">
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold"
                      >SAMPLE(S): <br />
                      SCREENING
                    </span>
                  </span>
                </p>

                <!-- Table -->
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">NASOPHARYNGEAL</th>
                      <th scope="row">xxxxxxxxxxx</th>
                    </tr>
                    <tr>
                      <th scope="row">OROPHARYNGEAL</th>
                      <th scope="row">xxxxxxxxxxx</th>
                    </tr>
                    <tr>
                      <th scope="row">SPUTUM</th>
                      <th scope="row"></th>
                    </tr>
                    <tr>
                      <th scope="row">BLOOD</th>
                      <th scope="row"></th>
                    </tr>
                    <tr>
                      <th scope="row">OTHERS</th>
                      <th scope="row"></th>
                    </tr>
                  </tbody>
                </table>
                <!-- Table End -->

                <p class="mt-4 mb-3 text-dark">
                  <span class="font-weight-bold">DATE OF RESULT: </span>
                  20/07/2021

                  <!-- <span class="font-weight-bold ml-3">VALIDITY: </span>
                  27/07/2021 -->
                </p>

                <!-- Table -->
                <table class="table table-light">
                  <tbody>
                    <tr>
                      <th scope="row">POSITIVE</th>
                      <th scope="row">X</th>
                    </tr>
                    <tr>
                      <th scope="row">NEGATIVE</th>
                      <th scope="row">-</th>
                    </tr>
                    <tr>
                      <th scope="row">INCONCLUSIVE</th>
                      <th scope="row"></th>
                    </tr>
                  </tbody>
                </table>
                <!-- Table End -->
              </div>
            </div>
          </div>

          <!-- Result -->
          <div class="row mt-5 ml-1">
            <span><span class="font-weight-bold">RESULT: </span></span>
          </div>

          <div class="container">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">S/N</th>
                  <th scope="col">TEST DONE</th>
                  <!-- <th scope="col">SAMPLE ID</th> -->
                  <th scope="col">LAB CODE (SPECIMEN USED)</th>
                  <th scope="col">REFERENCE RANGE</th>
                  <th scope="col">TEST VALUE</th>
                  <th scope="col">COMMENT</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">01</th>
                  <td>UY-HAR FOR JARS-COV2</td>
                  <!-- <td>849494949</td> -->
                  <td>LAB4848 (SPECIMEN B)</td>
                  <td>LEK3635</td>
                  <td>ABOVE CUTT OFF</td>
                  <!-- <td></td> -->
                  <td>NEGATIVE</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End Result -->

          <!-- Comment -->
          <div class="row mt-5">
            <div class="col-md-12 text-dark">
              <div class="border" style="border-radius: 20%; padding: 2%">
                <p>
                  <span class="font-weight-bold"><u>GENERAL COMMENT</u></span>
                </p>
                <p>
                  <span class="font-weight-bold"
                    >NEGATIVE FOR COV 2 (COVID-19) AS AT:
                  </span>
                  <u>23/07/2021</u>
                </p>
              </div>
              <!-- TODO: Uncomment when data is available in the response body-->
              <div>
                <!-- <p><span class="font-weight-bold">Signature: </span></p>
                  <p>............................</p> -->

                <p>
                  <span class="font-weight-bold">NAME: </span>
                  DR JOHN DOE
                </p>

                <p>
                  <span class="font-weight-bold">DESIGNATION: </span> HEAD OF
                  LABORATORY DEPARTMENT
                </p>
              </div>
            </div>
          </div>
          <!-- Comment  - End -->

          <!-- Contact Info box -->
          <!-- TODO: Uncomment when data is available in the response body -->
          <div class="row mt-5 mb-5">
            <div class="col-md-12 result-footer text-center p-3">
              <div class="">
                <span class="font-weight-bold">Address: </span>
                HEALTH CARE, EQUITORIAL GUINEA
              </div>
              <!-- <div class="">
                  <span class="font-weight-bold">Lagos: </span> 30b, Aba Johnson
                  Crecent, Adeniyi Jones, Ikeja, Lagos, Nigeria
                </div> -->
              <!-- <div class="">
                  <span class="font-weight-bold">PH: </span> 45, Eleinwo Street,
                  GRA Phase 1, Port Harcourt, Rivers, Nigeria
                </div> -->

              <hr />

              <div class="">
                <span class="font-weight-bold">Phone: </span>08048474838
                <span class="font-weight-bold ml-3">Email: </span>mail@gmail.com
                <!-- <span class="font-weight-bold ml-3">Twitter: </span>@MedBuryNG
                  <span class="font-weight-bold ml-3">Instagram: </span>@medburyng -->
              </div>
            </div>
          </div>
          <!-- Contact Info box -->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>
